import styled from "styled-components";

export const NavMenu = styled.nav.attrs(props => ({
    className: props.className,
}))`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
    visibility: hidden;
    background-color: var(--color-background);
    padding: 0 15px;
    overflow-y: auto;
    color: var(--color-text);

    &.open {
        z-index: 9999;
        visibility: visible;
        opacity: 1;
        transition: all .3s ease-in;
    }

    & .closeNav {
        width: 40px;
        height: 40px;
        font-size: 35px;
        line-height: 35px;
        position: absolute;
        top: 15px;
        right: 15px;
        color: var(--color-text);
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
        transition: all .3s ease;

        &::after {
            border-radius: 50%;
        }
    }

    & .nav-inner {
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    & ul {
        padding: 2rem;

        & li {
            display: block;
            text-align: center;
            cursor: pointer;

            & a {
                display: inline-block;
                font-size: 3rem;
                font-weight: 600;
                color: var(--color-text);
                padding: .5rem 3rem;
                border-radius: 30px;
                transition: all .3s ease;

                &::after {
                    border-radius: 30px;
                }

                &.active {
                    box-shadow: var(--shadow-main-inner) !important;
                    color: var(--color-primary-dark);
                }
            }
        }

        & li:not(:last-child) {
            margin-bottom: 2rem;
        }
    }

    & .copywrite {
        position: absolute;
        top: 50%;
        left: -6.5rem;
        font-size: 1.5rem;
        text-transform: capitalize;
        transform: translateY(-50%) rotate(-90deg);
    }
`;